/* Arco — theme.js
   Vanilla JS, carregado com defer. Sem dependências.
   Cada módulo é independente e só roda se o markup existir. */
(function () {
  'use strict';
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const safe = (fn) => { try { fn(); } catch (e) { if (window.console) console.warn('theme.js: módulo ignorado por erro', e); } };
  const money = (cents) => (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Rolagem horizontal animada (independe do suporte do navegador a scroll suave)
  const animateScroll = (el, left, duration = 450) => {
    const from = el.scrollLeft, delta = left - from;
    if (Math.abs(delta) < 2) return;
    if (reduceMotion()) { el.scrollLeft = left; return; }
    el.style.scrollSnapType = 'none';
    const t0 = performance.now();
    const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
    const step = (now) => {
      const p = Math.min(1, (now - t0) / duration);
      el.scrollLeft = from + delta * ease(p);
      if (p < 1) requestAnimationFrame(step); else el.style.scrollSnapType = '';
    };
    requestAnimationFrame(step);
  };
  let galleryApi = null;

  /* ---------- Carrosséis (reutilizável para conteúdo carregado depois) ---------- */
  function initCarousel(c) {
    const track = $('[data-carousel-track]', c), prev = $('[data-carousel-prev]', c), next = $('[data-carousel-next]', c);
    if (!track || c.dataset.ready) return;
    c.dataset.ready = '1';
    const update = () => {
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    };
    // Avança um "bloco" de itens inteiros, alinhado ao início do item (sem trancos do scroll-snap)
    const move = (dir) => {
      const item = track.firstElementChild;
      if (!item) return;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const w = item.getBoundingClientRect().width + gap;
      const perView = Math.max(1, Math.floor((track.clientWidth + gap) / w));
      const target = Math.round(track.scrollLeft / w + dir * perView) * w;
      animateScroll(track, Math.max(0, Math.min(target, track.scrollWidth - track.clientWidth)));
    };
    prev && prev.addEventListener('click', () => move(-1));
    next && next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }
  function initCarousels(root) { $$('[data-carousel]', root).forEach(initCarousel); }

  /* ---------- Remove produtos repetidos entre Compre junto / Quem comprou / Relacionados ---------- */
  function dedupe() {
    const seen = new Set();
    const main = $('[data-product]');
    if (main) seen.add(String(main.dataset.productId));
    $$('[data-buy-together] .bt-item[data-product-id]').forEach((li) => seen.add(String(li.dataset.productId)));
    $$('[data-recs-section]').forEach((sec) => {
      $$('.carousel__item', sec).forEach((item) => {
        const card = $('[data-product-id]', item);
        if (!card) return;
        const id = String(card.dataset.productId);
        if (seen.has(id)) item.remove(); else seen.add(id);
      });
      const has = !!$('.carousel__item', sec);
      if (!has && !sec.dataset.recsPending) sec.hidden = true;
      const t = $('[data-carousel-track]', sec);
      t && t.dispatchEvent(new Event('scroll'));
    });
  }

  /* ---------- Diálogos (modal de pagamento, lightbox) ---------- */
  const openDialog = (d) => { if (!d) return; if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', ''); document.body.classList.add('has-dialog'); };
  const closeDialog = (d) => { if (!d) return; if (typeof d.close === 'function') d.close(); else d.removeAttribute('open'); };
  document.addEventListener('click', (e) => {
    const c = e.target.closest('[data-modal-close]');
    if (c) { closeDialog(c.closest('dialog')); return; }
    if (e.target.tagName === 'DIALOG' && e.target.matches('.modal')) closeDialog(e.target); // clique no fundo
  });
  document.addEventListener('close', (e) => { if (e.target.tagName === 'DIALOG' && !$('dialog[open]')) document.body.classList.remove('has-dialog'); }, true);


  safe(() => {
  /* ---------- Drawers (menu mobile e filtros) ---------- */
  $$('[data-drawer-open]').forEach((btn) => {
    const id = btn.getAttribute('aria-controls');
    const drawer = document.getElementById(id);
    if (!drawer) return;
    const open = () => {
      drawer.hidden = false;
      drawer.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      const first = $('a, button, input', drawer.querySelector('.drawer__panel, .filters__panel'));
      first && first.focus();
    };
    const close = () => {
      drawer.classList.remove('is-open');
      if (!drawer.hasAttribute('data-drawer-desktop-static') || window.innerWidth <= 900) drawer.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      btn.focus();
    };
    btn.addEventListener('click', open);
    $$('[data-drawer-close]', drawer).forEach((c) => c.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !drawer.hidden) close(); });
  });
  // Filtros: visíveis no desktop, drawer no mobile
  const filters = $('[data-drawer-desktop-static]');
  if (filters) {
    const sync = () => { filters.hidden = window.innerWidth <= 900 && !filters.classList.contains('is-open'); };
    sync();
    window.addEventListener('resize', sync, { passive: true });
  }
  });

  safe(() => {
  /* ---------- Mega menu: acessível por teclado ---------- */
  $$('.nav__item--has-children > .nav__link').forEach((link) => {
    link.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const item = link.parentElement;
        const isOpen = item.classList.toggle('is-open');
        link.setAttribute('aria-expanded', String(isOpen));
      }
    });
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.nav__item')) $$('.nav__item.is-open').forEach((i) => i.classList.remove('is-open'));
  });
  });

  safe(() => {
  /* ---------- Carrosséis da página ---------- */
  initCarousels(document);
  });

  safe(() => {
  /* ---------- Hero: deslize suave (animação própria), dots e autoplay ---------- */
  const hero = $('[data-hero]');
  if (hero) {
    const dots = $$('[data-hero-dots] button');
    const slides = $$('.hero__slide', hero);
    const duration = 700; // ms do deslize
    let animating = false;
    const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
    const slideTo = (index) => {
      const target = hero.clientWidth * index, from = hero.scrollLeft;
      if (Math.abs(target - from) < 2 || animating) return;
      animating = true;
      hero.style.scrollSnapType = 'none';
      const t0 = performance.now();
      const step = (now) => {
        const p = Math.min(1, (now - t0) / duration);
        hero.scrollLeft = from + (target - from) * ease(p);
        if (p < 1) requestAnimationFrame(step);
        else { hero.style.scrollSnapType = ''; animating = false; setActive(); }
      };
      requestAnimationFrame(step);
    };
    const current = () => Math.round(hero.scrollLeft / hero.clientWidth);
    const setActive = () => { const i = current(); dots.forEach((d, j) => d.toggleAttribute('aria-current', j === i)); };
    dots.forEach((d, i) => d.addEventListener('click', () => slideTo(i)));
    hero.addEventListener('scroll', () => { if (!animating) setActive(); }, { passive: true });
    const autoplay = hero.dataset.autoplay !== 'false';
    const interval = Math.max(3, parseInt(hero.dataset.interval, 10) || 5) * 1000;
    if (slides.length > 1 && autoplay) {
      let paused = false, timer;
      const tick = () => { if (!paused && !document.hidden) slideTo((current() + 1) % slides.length); };
      const start = () => { clearInterval(timer); timer = setInterval(tick, interval); };
      ['mouseenter', 'focusin', 'touchstart', 'pointerdown'].forEach((ev) => hero.addEventListener(ev, () => { paused = true; }, { passive: true }));
      ['mouseleave', 'focusout', 'touchend', 'pointerup'].forEach((ev) => hero.addEventListener(ev, () => { paused = false; start(); }, { passive: true }));
      document.addEventListener('visibilitychange', () => { document.hidden ? clearInterval(timer) : start(); });
      start();
    }
  }
  });

  safe(() => {
  /* ---------- Busca preditiva (Shopify Predictive Search API): produtos no header, artigos no blog ---------- */
  $$('[data-predictive-input]').forEach((input) => {
    const results = input.parentElement.querySelector('[data-predictive-results]');
    if (!results) return;
    const type = input.dataset.predictiveType || 'product';
    let t, ctrl;
    const render = (data, q) => {
      const list = (data.resources.results[type + 's'] || []).slice(0, 6);
      if (!list.length) { results.innerHTML = `<p class="predictive__empty">Nenhum resultado para "${q}"</p>`; results.hidden = false; return; }
      results.innerHTML = list.map((p) => `
        <a class="predictive__item" href="${p.url}">
          ${p.image ? `<img src="${p.image}${p.image.includes('?') ? '&' : '?'}width=96" width="48" height="48" alt="" loading="lazy">` : ''}
          <span>${p.title}<b>${type === 'product' && p.price ? money(Math.round(parseFloat(p.price) * 100)) : (p.summary_html ? '' : '')}</b></span>
        </a>`).join('') +
        `<a class="predictive__all" href="/search?q=${encodeURIComponent(q)}&type=${type}">Ver todos os resultados para "${q}"</a>`;
      results.hidden = false;
    };
    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { results.hidden = true; return; }
      t = setTimeout(async () => {
        ctrl && ctrl.abort();
        ctrl = new AbortController();
        try {
          const r = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=${type}&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,vendor,body,tag`, { signal: ctrl.signal });
          render(await r.json(), q);
        } catch (e) { /* abortado ou offline */ }
      }, 220);
    });
    document.addEventListener('click', (e) => { if (!e.target.closest('form') || !e.target.closest('form').contains(input)) results.hidden = true; });
    input.addEventListener('keydown', (e) => { if (e.key === 'Escape') results.hidden = true; });
  });
  });

  /* ---------- Carrinho: helpers ---------- */
  async function cartAdd(items) {
    const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
    if (!r.ok) throw new Error((await r.json()).description || 'Não foi possível adicionar.');
    const cart = await (await fetch('/cart.js')).json();
    const count = $('[data-cart-count]'); if (count) { count.textContent = cart.item_count; count.hidden = false; }
    return cart;
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty]');
    if (!b) return;
    const i = b.parentElement.querySelector('input[name="quantity"]');
    if (i) i.value = Math.max(1, (parseInt(i.value, 10) || 1) + parseInt(b.dataset.qty, 10));
  });

  safe(() => {
  /* ---------- Cards: adicionar ao carrinho / comprar agora ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-card-form]');
    if (!form) return;
    e.preventDefault();
    const btn = $('[data-card-add]', form), txt = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adicionando...';
    try {
      await cartAdd([{ id: $('[name="id"]', form).value, quantity: parseInt($('[name="quantity"]', form).value, 10) || 1 }]);
      toast('Adicionado ao carrinho', '/cart', 'Ver carrinho');
    } catch (err) { toast(err.message); }
    finally { btn.disabled = false; btn.textContent = txt; }
  });
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-card-buy]');
    if (!b) return;
    const form = b.closest('[data-card-form]');
    b.disabled = true;
    try {
      await cartAdd([{ id: $('[name="id"]', form).value, quantity: parseInt($('[name="quantity"]', form).value, 10) || 1 }]);
      location.href = '/checkout';
    } catch (err) { toast(err.message); b.disabled = false; }
  });
  });

  safe(() => {
  /* ---------- Galeria do produto: setas, miniaturas, zoom, vídeo sob demanda e lightbox ---------- */
  const gal = $('[data-gallery]');
  if (!gal) return;
  const track = $('[data-gallery-track]', gal);
  const slides = $$('.gallery__slide', track);
  const thumbs = $$('[data-thumb-index]', gal);
  const list = $('[data-thumbs]', gal);
  const counter = $('[data-gallery-counter]', gal);
  const upBtn = $('[data-thumbs-prev]', gal), downBtn = $('[data-thumbs-next]', gal);
  let index = -1;

  const stopOthers = (keep) => slides.forEach((s, i) => {
    if (i === keep) return;
    const v = $('video', s); if (v && !v.paused) v.pause();
    if (s.dataset.embedded) { // YouTube/Vimeo: remove o iframe para parar o áudio
      const f = $('iframe', s); f && f.remove();
      const b = $('[data-embed]', s); if (b) b.hidden = false;
      delete s.dataset.embedded;
    }
  });
  const updateThumbNav = () => {
    if (!list) return;
    const vertical = list.scrollHeight > list.clientHeight + 2;
    if (upBtn) upBtn.disabled = !vertical || list.scrollTop <= 2;
    if (downBtn) downBtn.disabled = !vertical || list.scrollTop + list.clientHeight >= list.scrollHeight - 2;
  };
  const centerThumb = (t) => {
    if (!list || !t) return;
    const li = t.parentElement;
    if (list.scrollHeight > list.clientHeight + 2) list.scrollTo({ top: li.offsetTop - (list.clientHeight - li.offsetHeight) / 2, behavior: 'smooth' });
    else if (list.scrollWidth > list.clientWidth + 2) list.scrollTo({ left: li.offsetLeft - (list.clientWidth - li.offsetWidth) / 2, behavior: 'smooth' });
  };
  const setActive = (i) => {
    if (i === index || !slides[i]) return;
    index = i;
    thumbs.forEach((t, j) => { if (j === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    if (counter) counter.textContent = `${i + 1} / ${slides.length}`;
    centerThumb(thumbs[i]);
    stopOthers(i);
  };
  const goTo = (i, instant) => {
    if (!slides.length) return;
    i = (i + slides.length) % slides.length;
    const left = slides[i].offsetLeft;
    if (instant) track.scrollLeft = left; else animateScroll(track, left, 420);
    setActive(i);
  };
  let raf = 0;
  track.addEventListener('scroll', () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => setActive(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
  }, { passive: true });
  const prev = $('[data-gallery-prev]', gal), next = $('[data-gallery-next]', gal);
  prev && prev.addEventListener('click', () => goTo(index - 1));
  next && next.addEventListener('click', () => goTo(index + 1));
  thumbs.forEach((t) => t.addEventListener('click', () => goTo(parseInt(t.dataset.thumbIndex, 10))));
  track.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
  });
  if (list) {
    const page = (dir) => list.scrollBy({ top: dir * list.clientHeight * 0.8, left: dir * list.clientWidth * 0.8, behavior: 'smooth' });
    upBtn && upBtn.addEventListener('click', () => page(-1));
    downBtn && downBtn.addEventListener('click', () => page(1));
    list.addEventListener('scroll', updateThumbNav, { passive: true });
  }
  window.addEventListener('resize', () => { if (slides[index]) track.scrollLeft = slides[index].offsetLeft; updateThumbNav(); }, { passive: true });

  // Zoom no hover (desktop) — acompanha a posição do mouse
  $$('[data-zoom]', gal).forEach((z) => {
    z.addEventListener('mousemove', (e) => {
      const r = z.getBoundingClientRect();
      z.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
      z.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
    });
    z.addEventListener('mouseenter', () => z.classList.add('is-zooming'));
    z.addEventListener('mouseleave', () => z.classList.remove('is-zooming'));
  });

  // Vídeo do YouTube/Vimeo: o iframe só é criado no clique
  $$('[data-embed]', gal).forEach((b) => b.addEventListener('click', () => {
    const s = b.closest('.gallery__slide');
    const tpl = $('template[data-embed-template]', s);
    if (!tpl) return;
    s.appendChild(tpl.content.cloneNode(true));
    b.hidden = true;
    s.dataset.embedded = '1';
  }));

  // Lightbox (tela cheia) ao clicar na imagem
  const lb = $('[data-lightbox]');
  if (lb) {
    const ltrack = $('[data-lightbox-track]', lb);
    const lslides = $$('.lightbox__slide', ltrack);
    let lIndex = 0; // índice atual no lightbox (guardado porque, fechado, o lightbox não tem largura para medir)
    const current = () => lIndex;
    ltrack.addEventListener('scroll', () => { if (lb.open) lIndex = Math.round(ltrack.scrollLeft / Math.max(1, ltrack.clientWidth)); }, { passive: true });
    const lgo = (i) => { i = (i + lslides.length) % lslides.length; lIndex = i; animateScroll(ltrack, lslides[i].offsetLeft, 380); };
    $$('[data-zoom]', gal).forEach((z) => z.addEventListener('click', () => {
      const i = lslides.findIndex((s) => s.dataset.index === z.dataset.index);
      lIndex = Math.max(0, i);
      openDialog(lb);
      requestAnimationFrame(() => { if (lslides[lIndex]) ltrack.scrollLeft = lslides[lIndex].offsetLeft; });
    }));
    $('[data-lightbox-prev]', lb).addEventListener('click', () => lgo(current() - 1));
    $('[data-lightbox-next]', lb).addEventListener('click', () => lgo(current() + 1));
    $('[data-lightbox-close]', lb).addEventListener('click', () => closeDialog(lb));
    lb.addEventListener('click', (e) => { if (e.target.classList.contains('lightbox__slide')) closeDialog(lb); });
    lb.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') lgo(current() + 1);
      if (e.key === 'ArrowLeft') lgo(current() - 1);
    });
    // Ao fechar, a galeria fica na mesma imagem vista no lightbox
    lb.addEventListener('close', () => {
      const s = lslides[current()];
      if (s) goTo(parseInt(s.dataset.index, 10), true);
    });
  }

  galleryApi = {
    goToMedia(id) {
      const i = slides.findIndex((s) => s.dataset.mediaId === String(id));
      if (i >= 0) goTo(i);
    }
  };
  goTo(parseInt(gal.dataset.start, 10) || 0, true);
  updateThumbNav();
  });

  safe(() => {
  /* ---------- Opções de pagamento (cartão com/sem juros, PIX, boleto) ---------- */
  const openBtn = $('[data-payment-open]');
  const modal = $('[data-payment-modal]');
  const cfgEl = $('[data-payment-config]');
  if (!openBtn || !modal || !cfgEl) return;
  const cfg = JSON.parse(cfgEl.textContent);
  const productEl = $('[data-product]');
  const priceNow = () => parseInt(productEl ? productEl.dataset.price : 0, 10) || 0;
  // Tabela Price: parcela = PV * i / (1 - (1 + i)^-n)
  const pmt = (pv, i, n) => (i > 0 ? pv * i / (1 - Math.pow(1 + i, -n)) : pv / n);
  const render = () => {
    const price = priceNow();
    const free = Math.max(1, cfg.installments || 1);
    const rate = (parseFloat(String(cfg.rate).replace(',', '.')) || 0) / 100;
    // Taxa efetiva mensal e anual (Decreto 5.903/2006 e CDC art. 52: informar juros, parcelas e total a prazo)
    const pct = (x) => x.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%';
    const monthlyPct = pct(rate * 100);
    const annualPct = pct((Math.pow(1 + rate, 12) - 1) * 100);
    let hasInterest = false;
    const maxN = rate > 0 ? Math.max(1, cfg.max || 1) : Math.max(1, Math.min(cfg.max || free, free));
    const rows = [];
    let lastFree = 1;
    for (let n = 1; n <= maxN; n++) {
      const interest = n > free && rate > 0;
      const parcel = interest ? Math.round(pmt(price, rate, n)) : Math.round(price / n);
      if (n > 1 && cfg.min > 0 && parcel < cfg.min) break;
      if (!interest) lastFree = n;
      const total = interest ? parcel * n : price;
      if (interest) hasInterest = true;
      rows.push(`<tr><td><b>${n}x</b> de <b>${money(parcel)}</b></td><td class="pay-table__rate">${interest ? `${monthlyPct} a.m.` : '<span class="is-free">sem juros</span>'}</td><td>${money(total)}</td></tr>`);
    }
    $('[data-pay-table]', modal).innerHTML = rows.join('');
    const note = $('[data-pay-rate-note]', modal);
    if (note) {
      note.hidden = !hasInterest;
      note.innerHTML = hasInterest
        ? `Parcelamento em ${free + 1}x ou mais com juros de <b>${monthlyPct} ao mês</b> (<b>${annualPct} ao ano</b>), calculados pela Tabela Price. A coluna Total mostra o valor total a prazo. Preço à vista: <b>${money(price)}</b>.`
        : '';
    }
    $('[data-pay-card-lead]', modal).innerHTML = lastFree > 1
      ? `Em até <b>${lastFree}x de ${money(Math.round(price / lastFree))} sem juros</b> no cartão de crédito.`
      : `Total de <b>${money(price)}</b> no cartão de crédito.`;
    const pixEl = $('[data-pay-pix]', modal);
    if (pixEl) {
      const pix = Math.round(price * (100 - (cfg.pix || 0)) / 100);
      pixEl.innerHTML = `<strong>${money(pix)}</strong> à vista no PIX${cfg.pix > 0 ? ` · ${cfg.pix}% de desconto (economia de ${money(price - pix)})` : ''}`;
    }
    const bolEl = $('[data-pay-boleto]', modal);
    if (bolEl) {
      const bol = Math.round(price * (100 - (cfg.boleto || 0)) / 100);
      bolEl.innerHTML = `<strong>${money(bol)}</strong> à vista no boleto${cfg.boleto > 0 ? ` · ${cfg.boleto}% de desconto` : ''}`;
    }
  };
  const tabs = $$('[data-pay-tab]', modal);
  const select = (tab) => {
    tabs.forEach((t) => { const on = t === tab; t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; });
    $$('[data-pay-panel]', modal).forEach((p) => { p.hidden = p.dataset.payPanel !== tab.dataset.payTab; });
  };
  tabs.forEach((t, i) => {
    t.addEventListener('click', () => select(t));
    t.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
      select(n); n.focus();
    });
  });
  openBtn.addEventListener('click', () => { render(); if (tabs[0]) select(tabs[0]); openDialog(modal); });
  });

  safe(() => {
  /* ---------- Produto: variantes, galeria, quantidade, add to cart ---------- */
  const productEl = $('[data-product]');
  if (productEl) {
    const variants = JSON.parse($('[data-variants]', productEl).textContent);
    const form = $('[data-product-form]', productEl);
    const idInput = $('[data-variant-id]', form);
    const submit = $('[data-add-to-cart]', form);
    const label = $('[data-add-label]', form);
    const stock = $('[data-stock]', productEl);
    const priceWrap = $('[data-price-wrapper]', productEl);
    const buyNow = $('[data-buy-now]', form);
    const cfg = (() => { try { return JSON.parse($('[data-payment-config]').textContent); } catch (e) { return { installments: 1, min: 0, pix: 0, showPix: false }; } })();
    const installmentsFor = (price) => {
      let n = Math.max(1, cfg.installments || 1);
      if (cfg.min > 0) n = Math.min(n, Math.floor(price / cfg.min));
      return Math.max(1, n);
    };
    const renderPrice = (v) => {
      if (!v.available) { priceWrap.innerHTML = '<div class="price price--pdp"><span class="price__unavailable">Esgotado</span></div>'; return; }
      const n = installmentsFor(v.price);
      const pix = Math.round(v.price * (100 - (cfg.pix || 0)) / 100);
      priceWrap.innerHTML = `<div class="price price--pdp${v.compare_at_price > v.price ? ' price--sale' : ''}">
        ${v.compare_at_price > v.price ? `<span class="price__compare"><s>${money(v.compare_at_price)}</s></span>` : ''}
        <span class="price__current">${money(v.price)}</span>
        ${cfg.showPix && cfg.pix > 0 ? `<span class="price__pix">${money(pix)} <em>à vista no PIX</em></span>` : ''}
        ${n > 1 ? `<span class="price__installments">ou em ${n}x de ${money(Math.floor(v.price / n))} sem juros</span>` : ''}
      </div>`;
    };
    const setText = (sel, val) => $$(sel, productEl).forEach((el) => { el.textContent = val || ''; });
    const setHidden = (sel, hide) => $$(sel, productEl).forEach((el) => { el.hidden = hide; });

    const onVariantChange = () => {
      const selected = $$('[data-option-index]:checked', form).map((r) => r.value);
      const v = variants.find((x) => x.options.every((o, i) => o === selected[i])) || variants[0];
      if (!v) return;
      idInput.value = v.id;
      productEl.dataset.price = v.price;
      submit.disabled = !v.available;
      if (buyNow) buyNow.disabled = !v.available;
      label.textContent = v.available ? 'Adicionar ao carrinho' : 'Esgotado';
      setText('[data-sku]', v.sku); setHidden('[data-sku-pill], [data-sku-row]', !v.sku);
      setText('[data-barcode]', v.barcode); setHidden('[data-barcode-pill], [data-barcode-row]', !v.barcode);
      stock.textContent = v.available ? (v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 3 ? 'Últimas unidades' : 'Pronta entrega') : '';
      // Comprar / frete somem e o "Avise-me" aparece quando a variante está esgotada
      setHidden('[data-when-available]', !v.available);
      const notify = $('[data-notify]', productEl);
      if (notify) {
        notify.hidden = !!v.available;
        const tags = $('[data-notify-tags]', notify);
        if (tags) tags.value = tags.dataset.baseTags + (v.sku ? ',sku-' + v.sku : '');
      }
      renderPrice(v);
      if (v.featured_media && galleryApi) galleryApi.goToMedia(v.featured_media.id);
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
    };
    $$('[data-option-index]', form).forEach((r) => r.addEventListener('change', onVariantChange));

    const qtyOf = () => parseInt($('input[name="quantity"]', form).value, 10) || 1;
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      submit.disabled = true; label.textContent = 'Adicionando...';
      try {
        await cartAdd([{ id: idInput.value, quantity: qtyOf() }]);
        toast('Adicionado ao carrinho', '/cart', 'Ver carrinho');
      } catch (err) { toast(err.message || 'Não foi possível adicionar. Tente novamente.'); }
      finally { submit.disabled = false; label.textContent = 'Adicionar ao carrinho'; }
    });
    buyNow && buyNow.addEventListener('click', async () => {
      buyNow.disabled = true;
      try { await cartAdd([{ id: idInput.value, quantity: qtyOf() }]); location.href = '/checkout'; }
      catch (err) { toast(err.message); buyNow.disabled = false; }
    });

    // Calculadora de frete
    // 1) Frenet via Worker (Cloudflare) quando a URL está configurada — cota sem mexer no carrinho.
    // 2) Tarifas da Shopify (/cart/shipping_rates.json) como alternativa. Para o Brasil a Shopify exige
    //    o estado junto com o CEP, então o estado é buscado pelo CEP no ViaCEP antes da consulta.
    const calc = $('[data-shipping-calc]', productEl);
    const zipEl = calc && $('[data-shipping-zip]', calc), out = calc && $('[data-shipping-results]', calc), go = calc && $('[data-shipping-submit]', calc);
    if (calc && zipEl && out && go) {
      const addrEl = $('[data-shipping-address]', calc);
      const UF = { AC: 'Acre', AL: 'Alagoas', AP: 'Amapá', AM: 'Amazonas', BA: 'Bahia', CE: 'Ceará', DF: 'Distrito Federal', ES: 'Espírito Santo', GO: 'Goiás', MA: 'Maranhão', MT: 'Mato Grosso', MS: 'Mato Grosso do Sul', MG: 'Minas Gerais', PA: 'Pará', PB: 'Paraíba', PR: 'Paraná', PE: 'Pernambuco', PI: 'Piauí', RJ: 'Rio de Janeiro', RN: 'Rio Grande do Norte', RS: 'Rio Grande do Sul', RO: 'Rondônia', RR: 'Roraima', SC: 'Santa Catarina', SP: 'São Paulo', SE: 'Sergipe', TO: 'Tocantins' };
      const esc = (t) => String(t == null ? '' : t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      const days = (a, b) => {
        a = parseInt(a, 10); b = parseInt(b, 10);
        if (!a) return '';
        return (b && b !== a ? `${a} a ${b}` : `${a}`) + (Math.max(a, b || 0) === 1 ? ' dia útil' : ' dias úteis');
      };
      const renderRates = (rates) => {
        if (!rates.length) { out.innerHTML = '<p class="is-error">Não encontramos opções de frete para este CEP. Fale conosco pelo WhatsApp.</p>'; return; }
        rates.sort((x, y) => x.price - y.price);
        out.innerHTML = '<ul>' + rates.map((r) => `<li><span>${esc(r.name)}${r.days ? `<small>${esc(r.days)}</small>` : ''}</span><b>${r.price === 0 ? 'Grátis' : money(r.price)}</b></li>`).join('') + '</ul>';
      };
      const lookupCep = async (cep) => {
        try {
          const r = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
          const j = await r.json();
          return j && !j.erro ? j : null;
        } catch (e) { return null; }
      };
      const currentVariant = () => variants.find((x) => String(x.id) === String(idInput.value)) || variants[0];

      const quoteFrenet = async (cep) => {
        const v = currentVariant();
        const qty = qtyOf();
        const [h, w, l] = (calc.dataset.dims || '20x20x20').split('x').map((n) => parseFloat(String(n).replace(',', '.')) || 20);
        // A Shopify guarda o peso em gramas; a Frenet espera quilos
        const kg = v.weight > 0 ? v.weight / 1000 : (parseFloat(calc.dataset.defaultWeight) || 1);
        const body = {
          SellerCEP: calc.dataset.sellerCep,
          RecipientCEP: cep,
          ShipmentInvoiceValue: Number(((v.price * qty) / 100).toFixed(2)),
          ShippingServiceCode: null,
          RecipientCountry: 'BR',
          ShippingItemArray: [{ Height: h, Width: w, Length: l, Weight: Number(kg.toFixed(3)), Quantity: qty, SKU: v.sku || String(v.id), Category: '' }]
        };
        const r = await fetch(calc.dataset.proxy, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        if (!r.ok) throw new Error('proxy ' + r.status);
        const j = await r.json();
        const list = j.ShippingSevicesArray || j.ShippingServicesArray || j.services || [];
        return list
          .filter((s) => !s.Error && s.ShippingPrice != null)
          .map((s) => ({
            name: [s.Carrier, s.ServiceDescription].filter(Boolean).join(' · ') || 'Entrega',
            price: Math.round(parseFloat(String(s.ShippingPrice).replace(',', '.')) * 100),
            days: days(s.DeliveryTime)
          }))
          .filter((s) => !isNaN(s.price));
      };

      const quoteShopify = async (cep, addr) => {
        const vid = idInput.value;
        let temp = false;
        try {
          const cart = await (await fetch('/cart.js')).json();
          if (!cart.items.some((i) => String(i.variant_id) === String(vid))) {
            const add = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: vid, quantity: qtyOf() }) });
            if (add.ok) temp = true;
          }
          const zip = cep.replace(/^(\d{5})(\d{3})$/, '$1-$2');
          const tryRates = async (province) => {
            const params = new URLSearchParams({ 'shipping_address[zip]': zip, 'shipping_address[country]': 'Brazil' });
            if (province) params.set('shipping_address[province]', province);
            const q = params.toString();
            const r = await fetch(`/cart/shipping_rates.json?${q}`);
            let d = {};
            try { d = await r.json(); } catch (e) { d = {}; }
            if (d.shipping_rates) return d.shipping_rates;
            if (r.status === 422) return null; // endereço recusado: tenta o próximo formato de estado
            // Tarifas calculadas por apps (ex.: Frenet) chegam de forma assíncrona
            await fetch(`/cart/prepare_shipping_rates.json?${q}`, { method: 'POST' });
            for (let i = 0; i < 8; i++) {
              await new Promise((res) => setTimeout(res, 700));
              const a = await fetch(`/cart/async_shipping_rates.json?${q}`);
              if (a.status === 200) { const j = await a.json(); if (j.shipping_rates) return j.shipping_rates; }
            }
            return [];
          };
          let list = null;
          const provinces = addr && UF[addr.uf] ? [UF[addr.uf], addr.uf] : [null];
          for (const prov of provinces) { list = await tryRates(prov); if (list) break; }
          const data = { shipping_rates: list || [] };
          return (data.shipping_rates || []).map((x) => ({
            name: x.presentment_name || x.name,
            price: Math.round(parseFloat(x.price) * 100),
            days: x.delivery_days && x.delivery_days.length ? days(x.delivery_days[0], x.delivery_days[1]) : ''
          }));
        } finally {
          if (temp) { try { await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: String(vid), quantity: 0 }) }); } catch (e) { /* ignora */ } }
        }
      };

      zipEl.addEventListener('input', () => { zipEl.value = zipEl.value.replace(/\D/g, '').slice(0, 8).replace(/^(\d{5})(\d)/, '$1-$2'); });
      zipEl.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); go.click(); } });
      go.addEventListener('click', async () => {
        const cep = zipEl.value.replace(/\D/g, '');
        if (cep.length !== 8) { out.innerHTML = '<p class="is-error">Informe um CEP com 8 dígitos.</p>'; return; }
        go.disabled = true; out.innerHTML = '<p class="shipping-calc__loading">Calculando...</p>';
        try { localStorage.setItem('sf_cep', cep); } catch (e) { /* navegação privada */ }
        const addr = await lookupCep(cep);
        if (addrEl && calc.dataset.showAddress === 'true') {
          addrEl.hidden = !addr;
          if (addr) addrEl.textContent = [addr.logradouro, addr.bairro, `${addr.localidade}/${addr.uf}`].filter(Boolean).join(', ');
        }
        let rates = [];
        try {
          if (calc.dataset.proxy) {
            try { rates = await quoteFrenet(cep); } catch (e) { if (window.console) console.warn('Frete Frenet indisponível, usando a Shopify', e); }
          }
          if (!rates.length) rates = await quoteShopify(cep, addr);
          renderRates(rates);
        } catch (err) {
          out.innerHTML = '<p class="is-error">Não foi possível calcular agora. Tente novamente ou fale conosco pelo WhatsApp.</p>';
        } finally { go.disabled = false; }
      });
      // Lembra o último CEP digitado
      try { const saved = localStorage.getItem('sf_cep'); if (saved && !zipEl.value) zipEl.value = saved.replace(/^(\d{5})(\d{3})$/, '$1-$2'); } catch (e) { /* ignora */ }
    }

    // Compre junto
    const btWrap = $('[data-buy-together-wrap]');
    if (btWrap && $('[data-buy-together]', btWrap)) {
      const bt = $('[data-buy-together]', btWrap);
      const totalEl = $('[data-bt-total]', bt), countEl = $('[data-bt-count]', bt), addBtn = $('[data-bt-add]', bt), list = $('[data-bt-list]', bt);
      const items = () => $$('[data-bt-item]', bt);
      const update = () => {
        let total = 0, n = 0;
        items().forEach((c) => {
          const li = c.closest('.bt-item'); li.classList.toggle('is-off', !c.checked);
          const sel = li.querySelector('[data-bt-variant]');
          if (sel) { c.dataset.id = sel.value; c.dataset.price = sel.selectedOptions[0].dataset.price; const lab = li.querySelector('[data-bt-price-label]'); if (lab) lab.textContent = money(parseInt(c.dataset.price, 10)); }
          if (c.checked) { total += parseInt(c.dataset.price, 10); n++; }
        });
        totalEl.textContent = money(total); countEl.textContent = n; addBtn.disabled = n === 0;
      };
      bt.addEventListener('change', update); update();
      addBtn.addEventListener('click', async () => {
        addBtn.disabled = true;
        try { await cartAdd(items().filter((c) => c.checked).map((c) => ({ id: c.dataset.id, quantity: 1 }))); toast('Produtos adicionados ao carrinho', '/cart', 'Ver carrinho'); }
        catch (err) { toast(err.message); }
        finally { addBtn.disabled = false; }
      });
      // Tenta melhorar os complementares com a Recommendations API (complementary, depois related).
      if (btWrap.dataset.url) {
        const tryIntent = async (intent) => {
          const html = await (await fetch(`${btWrap.dataset.url}&intent=${intent}`)).text();
          return $$('[data-bt-recs] li', new DOMParser().parseFromString(html, 'text/html'));
        };
        (async () => {
          try {
            let recs = await tryIntent('complementary');
            if (!recs.length) recs = await tryIntent('related');
            if (recs.length) { $$('[data-bt-rec]', list).forEach((li) => li.remove()); recs.forEach((li) => list.appendChild(li)); update(); dedupe(); }
          } catch (e) { /* mantém o fallback da coleção */ }
        })();
      }
    }
  }
  });

  safe(() => {
  /* ---------- Recomendações carregadas depois (Quem comprou, comprou também / Relacionados) ---------- */
  const secs = $$('[data-recs-section][data-recs-url]');
  secs.forEach((s) => { s.dataset.recsPending = '1'; });
  const load = async (sec) => {
    try {
      const html = await (await fetch(sec.dataset.recsUrl)).text();
      const res = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recs-result]');
      const items = res ? $$('.carousel__item', res) : [];
      if (items.length) {
        const track = $('[data-carousel-track]', sec);
        track.innerHTML = '';
        items.forEach((it) => track.appendChild(document.importNode(it, true)));
        track.scrollLeft = 0;
        sec.hidden = false;
      }
    } catch (e) { /* mantém a coleção de reserva, se houver */ }
    delete sec.dataset.recsPending;
    if (!$('.carousel__item', sec)) sec.hidden = true;
    initCarousels(sec);
    dedupe();
  };
  if ('IntersectionObserver' in window) {
    // Seções ocultas não têm caixa visível: observa um marcador de 1px logo antes de cada uma
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (e.isIntersecting) { io.unobserve(e.target); load(e.target.recsTarget); }
    }), { rootMargin: '600px 0px' });
    secs.forEach((s) => {
      const mark = document.createElement('div');
      mark.style.height = '1px';
      mark.recsTarget = s;
      s.parentNode.insertBefore(mark, s);
      io.observe(mark);
    });
  } else {
    secs.forEach(load);
  }
  dedupe();
  });

  /* ---------- Avise-me: consentimento de newsletter adiciona a tag "newsletter" ---------- */
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-notify-form]');
    if (!f) return;
    const c = $('[data-notify-consent]', f), t = $('[data-notify-tags]', f);
    if (c && t && c.checked && !/(^|,)newsletter(,|$)/.test(t.value)) t.value += ',newsletter';
  });

  safe(() => {
  /* ---------- Coleção: ordenação e filtros ---------- */
  $$('[data-autosubmit]').forEach((s) => s.addEventListener('change', () => s.form.submit()));
  const filterForm = $('[data-filter-form]');
  if (filterForm) {
    // Remove campos vazios da URL (URLs limpas para SEO)
    filterForm.addEventListener('submit', () => {
      $$('input', filterForm).forEach((i) => { if (i.type !== 'checkbox' && i.value === '') i.disabled = true; });
    });
  }
  });

  safe(() => {
  /* ---------- Texto SEO recolhível ("Leia mais") ---------- */
  const findBox = (btn) => {
    const scope = btn.closest('.seo-text') || btn.closest('.container') || btn.closest('section');
    return (scope && scope.querySelector('[data-collapsible]')) || (btn.parentElement && btn.parentElement.previousElementSibling);
  };
  $$('[data-collapsible-toggle]').forEach((btn) => {
    const box = findBox(btn);
    if (!box) return;
    btn.dataset.label = btn.textContent.trim();
    if (box.scrollHeight <= 340) { box.classList.remove('is-collapsible'); btn.hidden = true; }
  });
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-collapsible-toggle]');
    if (!btn) return;
    e.preventDefault();
    const box = findBox(btn);
    if (!box) return;
    const open = !box.classList.contains('is-expanded');
    box.classList.toggle('is-expanded', open);
    box.classList.toggle('is-collapsible', !open);
    box.style.maxHeight = open ? 'none' : '';
    btn.setAttribute('aria-expanded', String(open));
    btn.textContent = open ? 'Mostrar menos' : (btn.dataset.label || 'Leia mais');
    if (!open) box.scrollIntoView({ block: 'start', behavior: 'smooth' });
  });
  });

  safe(() => {
  /* ---------- Artigo: sumário a partir dos H2 ---------- */
  const content = $('[data-article-content]');
  const toc = $('[data-toc]');
  if (content && toc) {
    const hs = $$('h2', content);
    if (hs.length >= 3) {
      const list = $('[data-toc-list]', toc);
      hs.forEach((h, i) => {
        if (!h.id) h.id = 'sec-' + (i + 1) + '-' + h.textContent.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '').slice(0, 50);
        const li = document.createElement('li'); li.innerHTML = `<a href="#${h.id}">${h.textContent}</a>`; list.appendChild(li);
      });
      toc.hidden = false;
      if ('IntersectionObserver' in window) {
        const links = $$('a', list);
        const spy = new IntersectionObserver((es) => es.forEach((e) => {
          if (e.isIntersecting) links.forEach((a) => a.classList.toggle('is-active', a.getAttribute('href') === '#' + e.target.id));
        }), { rootMargin: '-20% 0px -70% 0px' });
        hs.forEach((h) => spy.observe(h));
      }
    }
  }
  });

  /* ---------- Toast ---------- */
  function toast(msg, href, linkText) {
    $$('.toast').forEach((t) => t.remove());
    const el = document.createElement('div');
    el.className = 'toast'; el.setAttribute('role', 'status');
    el.innerHTML = `<span>${msg}</span>${href ? `<a href="${href}">${linkText}</a>` : ''}`;
    document.body.appendChild(el);
    setTimeout(() => el.remove(), 5000);
  }
})();
